import React from "react";
import {logout} from '../providers/providers.js'
import store from '../store'
import connect from "react-redux/es/connect/connect";


const stateMap = (store) => {
    return {
        user: store.user
    };
};

class Logout extends React.Component {

    componentDidMount() {
        localStorage.clear()
        store.dispatch(logout()).then(() => {
        },(error) => {
            if (error.toString().includes("403")) {
                this.props.history.push("/");
            }
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if(!this.props.user.entity.fetched){
            this.props.history.push("/")
        }
    }

    render() {
        return null
    }

}

export default connect(stateMap)(Logout);
